import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  CanDeactivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { SessionService } from "./session.service";

@Injectable()
export class LoginguardService implements CanActivate {
  constructor(public router: Router, private sessionService: SessionService) {}

  canActivate(): boolean {
    if (this.isAuthenticated()) {
      this.router.navigate(["/all-bids/bid"]);
      return false;
    } else return true;
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem("token");
    return !!token;
  }
}
